export default "__VITE_ASSET__AW48itlk__"